module.exports = __webpack_public_path__ + "static/img/V4.9df71b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/V4.png
// module id = CVb/
// module chunks = 1